// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__QXFMt","actions":"style_actions__JO+yR","actions_btn":"style_actions_btn__FurUY"};